import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../api';
import EtaHint from '../components/EtaHint';
import { pushToast } from '../hooks/useToasts';
// Resoluciones ofrecidas en el selector (altura máxima en px).
const HEIGHTS = [
    { label: 'auto', value: null },
    { label: '720p', value: 720 },
    { label: '1080p', value: 1080 },
    { label: '1440p', value: 1440 },
    { label: '2160p (4K)', value: 2160 },
];
const CONTAINERS = ['mp4', 'mkv', 'webm'];
/**
 * /analyze — descarga el vídeo procesado por la plataforma de streaming
 * directamente desde su URL (vía yt-dlp en el backend), con opciones gráficas
 * de resolución, formato, calidad y audio. El resultado es un job descargable
 * que luego puede compararse con el original en /compare (modo vídeo).
 */
export default function Analyze() {
    const { t } = useTranslation();
    const nav = useNavigate();
    const [url, setUrl] = useState('');
    const [maxHeight, setMaxHeight] = useState(null);
    const [container, setContainer] = useState('mp4');
    const [quality, setQuality] = useState('best');
    const [includeAudio, setIncludeAudio] = useState(false);
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState(null);
    const onSubmit = async (e) => {
        e.preventDefault();
        if (!url.trim())
            return;
        setBusy(true);
        setError(null);
        try {
            await api.post('/jobs/fetch', {
                url: url.trim(),
                maxHeight,
                container,
                quality,
                includeAudio,
            });
            pushToast({ kind: 'info', title: t('jobLaunched.title'), msg: t('jobLaunched.msg') });
            nav('/dashboard');
        }
        catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        }
        finally {
            setBusy(false);
        }
    };
    return (_jsxs("section", { className: "prose", children: [_jsx("h1", { children: t('analyze.title') }), _jsx("p", { className: "muted", children: t('analyze.subtitle') }), _jsxs("form", { onSubmit: onSubmit, className: "card form-card", children: [_jsxs("label", { children: [t('analyze.url'), _jsx("input", { type: "url", required: true, placeholder: "https://www.youtube.com/watch?v=\u2026", value: url, onChange: (e) => setUrl(e.target.value) })] }), _jsxs("label", { children: [t('analyze.resolution'), _jsx("div", { className: "chip-row", children: HEIGHTS.map((h) => (_jsx("button", { type: "button", className: `chip ${maxHeight === h.value ? 'active' : ''}`, onClick: () => setMaxHeight(h.value), children: h.label }, h.label))) })] }), _jsxs("div", { className: "grid-2", children: [_jsxs("label", { children: [t('analyze.format'), _jsx("select", { value: container, onChange: (e) => setContainer(e.target.value), children: CONTAINERS.map((c) => _jsx("option", { value: c, children: c }, c)) })] }), _jsxs("label", { children: [t('analyze.quality'), _jsxs("select", { value: quality, onChange: (e) => setQuality(e.target.value), children: [_jsx("option", { value: "best", children: t('analyze.qualityBest') }), _jsx("option", { value: "worst", children: t('analyze.qualityWorst') })] })] })] }), _jsxs("label", { className: "checkbox-field", children: [_jsx("input", { type: "checkbox", checked: includeAudio, onChange: (e) => setIncludeAudio(e.target.checked) }), t('analyze.includeAudio')] }), error && _jsx("p", { className: "error", children: error }), _jsx(EtaHint, { kind: "fetch" }), _jsx("button", { type: "submit", className: "btn btn-primary", disabled: busy || !url.trim(), children: busy ? t('common.loading') : t('analyze.submit') })] })] }));
}
